
import { useState } from 'react';

import { useSelector } from 'react-redux';

import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';

import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import FileCopyIcon from '@mui/icons-material/FileCopy';

import { MdLaunch } from "react-icons/md";

import { RootState } from '../store';

import { DialogContentStyle, DialogActionsStyle } from '../styles/DialogStyle';

export const BoxEnvioElectronico = () => {

    const { folioBuzonElectronico, escritoBuzonElectronico, anexosBuzonElectronico } = useSelector( ( state: RootState ) => state.recepcion );

    const [open, setOpen] = useState( false );
    const [documento, setDocumento] = useState( '' );

    const [openAnexos, setOpenAnexos] = useState( false );  
    const [fullScreen, setFullScreen] = useState( false );

    return (
        <Grid size={12} sx={{ mb: 1 }}>

            <Grid container spacing={3}>

                <Grid size={ anexosBuzonElectronico?.length !== 0 ? 4 : 6 }>

                    <Grid container spacing={1}>

                        <Grid size={{ md: 7, xs: 12 }}>
                            <Typography variant="subtitle1"> <strong>Trámite enviado por buzón electrónico</strong> </Typography>                            
                        </Grid>
                        
                        <Grid size={{ md: 5, xs: 12 }}>

                            <Chip
                                variant='outlined'   
                                color="secondary"
                                sx={{ p: 2 }}
                                icon={ <ForwardToInboxIcon fontSize="small" /> }
                                label={ 
                                    <Typography variant="button" fontWeight={'600'} sx={{ ml: 1 }}> 
                                        { folioBuzonElectronico } 
                                    </Typography> 
                                }
                            />
                            
                        </Grid>

                    </Grid>

                </Grid>   

                <Grid size={ anexosBuzonElectronico?.length !== 0 ? 4 : 6 } textAlign={'center'}>

                    <Button
                        fullWidth
                        variant='contained'
                        onClick={ () => { setDocumento( escritoBuzonElectronico ?? '' ); setOpen( true ); } }
                    >
                        Visualizar escrito
                    </Button>

                </Grid>

                {
                    anexosBuzonElectronico?.length !== 0
                    &&
                        <Grid size={4} textAlign={'center'}>

                            <Button
                                fullWidth
                                variant='contained'
                                onClick={ () => setOpenAnexos( true ) }
                            >
                                Visualizar anexo(s) adjunto(s)
                            </Button>

                        </Grid>
                }

            </Grid>     

            <Dialog
                maxWidth="md"
                fullWidth={ true } 
                open={ open } 
                fullScreen={ fullScreen } 
                onClose={ () => {} } 
            >       

                <DialogTitle sx={{ backgroundColor: '#3c3c3c', p: 0, textAlign: 'end' }}>

                    <IconButton sx={{ color: 'white' }} onClick={ () => window.open( documento, '_blank' ) }>
                        <MdLaunch fontSize={20} />
                    </IconButton>
                
                    <IconButton size='small' sx={{ color: 'white' }} onClick={ () => setFullScreen( (prev) => !prev ) }>
                        { fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon /> } 
                    </IconButton>

                    <IconButton size='small' sx={{ color: 'white' }} onClick={ () => setOpen( false ) }>
                        <CloseIcon />
                    </IconButton>
                
                </DialogTitle>        
                
                <DialogContent sx={{ p: 0 }}>
                    
                    <Grid container spacing={3} height={'100%'} >                                                
                    
                        <Grid size={{ md: 12, xs: 12}} sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
    
                            {
                                documento
                                ?
                                    <iframe title='acuse' src={ documento } height={ fullScreen ? "100%" : '500px' } width="100%" style={{ border: 'none' }}></iframe>
                                :
                                    <Typography variant='subtitle2' sx={{ fontSize: 18, fontWeight: 'bold', mt: 10, mb: 10 }}>
                                        No se encontró el documento
                                    </Typography>                          
                            }

                        </Grid>
                        
                    </Grid>
                    
                </DialogContent> 

            </Dialog>    

            <Dialog 
                fullWidth
                maxWidth="xs" 
                open={ openAnexos } 
                onClose={ () => {} } 
            >

                <DialogTitle>
                    Anexos
                </DialogTitle>
                
                <DialogContent sx={ DialogContentStyle }>
                    
                    <List disablePadding sx={{ mt: 3 }} >
    
                        {
                            anexosBuzonElectronico?.map( ( { nombre, url }, index ) => (
                                
                                <ListItemButton 
                                    divider 
                                    key={ index } 
                                    sx={{ py: 2 }}
                                    onClick={ () => { 
                                        setDocumento( url ); 
                                        setOpen( true ); 
                                    }}                                    
                                >
                                    <ListItemIcon>
                                        <FileCopyIcon color='secondary' />
                                    </ListItemIcon>

                                    <ListItemText primary={ <Typography variant='body2' fontWeight={'600'}>{ nombre }</Typography> } />

                                </ListItemButton>

                            ))
                        }

                    </List>
                    
                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color="secondary" onClick={ () => { setOpenAnexos( false ); } }>
                        Cerrar
                    </Button>

                </DialogActions>                

            </Dialog>  
            
        </Grid>
    )
}
